import { render, staticRenderFns } from "./DialogAvatar.vue?vue&type=template&id=07bb5688&scoped=true"
import script from "./DialogAvatar.vue?vue&type=script&lang=js"
export * from "./DialogAvatar.vue?vue&type=script&lang=js"
import style0 from "./DialogAvatar.vue?vue&type=style&index=0&id=07bb5688&prod&scoped=true&lang=css"
import style1 from "./DialogAvatar.vue?vue&type=style&index=1&id=07bb5688&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb5688",
  null
  
)

export default component.exports